<template>
  <div class="deviceManagementList">
    <div class="filters">
      <el-form :inline="true">
        <!-- 左上选择全部小区时，小区下拉列表可点击状态 -->
        <el-form-item v-if="this.gardenId === 0">
          <el-select v-model="gardenIdId">
            <el-option key :label="$t('lang.villageall')" :value="0"></el-option>
            <el-option v-for="(item,index) in types" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 左上选择固定小区时，小区下拉列表不可点击状态 -->
        <el-form-item v-if="this.gardenId != 0">
          <el-select v-model="gardenId" :disabled="this.gardenId != 0">
            <el-option v-for="(item,index) in types" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <!-- 关键字搜索 -->
          <el-input class="searchInput" v-model="macKeyword"
            :placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_name')"></el-input>
        </el-form-item>
        <!-- 设备分类 -->
        <el-form-item>
          <el-select v-model="deviceTypesOf">
            <el-option key label="请选择设备分类" value></el-option>
            <el-option v-for="(item,index) in deviceTypesOfList" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 查询按钮 -->
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
        <el-button type="primary" @click="download()">{{$t('lang.btn_downloadTemplate')}}</el-button>
        <el-upload class="upload-demo" ref="uploading" :on-remove="handleRemove" :on-change="handleSuccess"
          :on-error="uploadErr1" accept=".xlsx, .xls" action :file-list="fileList" :limit="1" :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
        </el-upload>
      </el-form>
    </div>
    <el-card>
      <!-- 添加设备 -->
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_deviceManagementAdd')}}</el-button>
      <el-button type="primary" slot="header" @click="excelDownloadClick">{{$t('lang.btn_excelDl')}}</el-button>

      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <!-- 序号功能 -->
        <el-table-column type="index" :index="indexMethod" :label="$t('lang.lab_index')" align="center" width="100px">
        </el-table-column>
        <!-- 所属项目 -->
        <el-table-column prop="gardenName" label="所属项目"></el-table-column>
        <!-- 设备名称 -->
        <el-table-column prop="name" :label="$t('lang.lbl_deviceManagement_name')" width="310px">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.name&&scope.row.name.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.name }}
                </span>
              </div>
              <div>
                {{ scope.row.name.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span v-if="scope.row.name.length>require('@/config/enum').tableDatamaxlength">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.name | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
		<!-- 主要参数3 -->
		<el-table-column prop="param3" :label="$t('lang.lbl_deviceManagement_param3')"></el-table-column>
        <!-- 设备编号 -->
        <el-table-column prop="deviceNo" :label="$t('lang.lbl_deviceManagement_deviceNo')"></el-table-column>
        <!-- 设备分类 -->
        <el-table-column label="设备分类">
          <template slot-scope="scope">
						{{scope.row.deviceTypesOf? scope.row.deviceTypesOf: '--'}}
					</template>
        </el-table-column>
        <!-- 主要参数1 -->
        <el-table-column prop="param1" :label="$t('lang.lbl_deviceManagement_param1')"></el-table-column>
        <!-- 主要参数2 -->
        <el-table-column prop="param2" :label="$t('lang.lbl_deviceManagement_param2')"></el-table-column>
        <!-- 数量 -->
        <el-table-column prop="count" :label="$t('lang.lbl_deviceManagement_count')" width="100px"></el-table-column>
        <!-- 规格 -->
        <el-table-column prop="unit" :label="$t('lang.lbl_deviceManagement_unit')" width="100px"></el-table-column>
        <!-- 规格 -->
        <el-table-column prop="url" label="设备扫码信息">
          <template slot-scope="scope">
            <a :href="scope.row.url" target="_blank">{{scope.row.url}}</a>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <!-- 修改设备 -->
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <!-- 删除设备 -->
            <el-button class="orange" @click="deletetable(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50,1000]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
  // 引入富文本title汉字
  import {
    excelDownload
  } from '../../../config/download.js'
  /**
   *@ClassName:deviceManagementList
   *@Description:设备管理列表
   *@author:刘彦辰
   *@Copyright:格众科技
   *@date:2020-03-23
   */

  export default {
    name: '/manage/main.deviceList',
    data() {
      return {
        gardenId: this.$store.getters.gardenId,
        pageCount: 0, // 总页数
        pageNo: 1, // 第几页
        pageSize: 10, // 每页显示数
        tableData: [], // 列表数组
        postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
        isDisabled: true, // 保存的可点击
        isPopupPage: false, // 弹框的显示控制
        isAdd: false, // 标识新增(true)或编辑(false)
        multipleSelection: [], // 多选框
        gardenIdId: this.$store.getters.gardenId, // 小区ID接口绑定
        types: [], // 小区列表
        macKeyword: '', // 关键字查询
        name: '', // 电梯设备名称
        macName: '', // 电梯设备Mac地址
        fileList: [],
        deviceTypesOf: '', // 设备分类（新）
        deviceTypesOfList: [
					{
						name: '工程',
					},
					{
						name: '客服',
					},
					{
						name: '秩序',
					},
					{
						name: '保洁',
					},
					{
						name: '绿化',
					},
				], // 设备分类列表
      }
    },
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.commit()
      }
    },
    created() {
      // #8449 add
      setTimeout(() => {
        window.localStorage.setItem('deviceManagementForm', '')
      }, 200)
      this.getTablelist()
      this.getGardenId()
    },
    activated() {
      this.getTablelist()
      this.getGardenId()
    },
    methods: {
      // 下载模板
      download() {
        window.open(require('@/config/enum').mouldDevice)
      },
      // 上传文件的断网
      uploadErr1() {
        if (!navigator.onLine || window.navigator.onLine === false) {
          const loading = this.$loading()
          setTimeout(() => {
            loading.close()
            this.$message.error(this.$i18n.t('lang.lab_Online'))
          }, 500)
        }
      },
      handleSuccess(e) {
        this.fileLists = e.raw
      },
      // 移除文件
      handleRemove() {
        this.fileList = []
        this.fileLists.length = 0
      },
      // 图片上传数量超过提醒
      outlimit() {
        this.$message.warning(this.$i18n.t('lang.lab_uploadWarning'))
      },
      // 导入业主按钮
      submitUpload() {
        if (this.fileLists.length < 1) {
          this.$message.warning(this.$i18n.t('lang.key_up_file'))
        } else {
          let formData = new FormData()
          formData.append('excelFile', this.fileLists)
          let loading = this.$loading()
          this.$postFormData(`/importDevice`, formData).then(
            res => {
              loading.close()
              this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
              this.fileList = []
              this.commit()
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      },
      // 列表隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 表格下载
      excelDownloadClick() {
        if (navigator.onLine) {
          // Excel表头
          const tHeader = [
            '所属项目',
            this.$i18n.t('lang.lbl_deviceManagement_name'),
            this.$i18n.t('lang.lbl_deviceManagement_deviceNo'),
            this.$i18n.t('lang.lbl_deviceManagement_param1'),
            this.$i18n.t('lang.lbl_deviceManagement_param2'),
            this.$i18n.t('lang.lbl_deviceManagement_param3'),
            this.$i18n.t('lang.lbl_deviceManagement_count'),
            this.$i18n.t('lang.lbl_deviceManagement_unit'),
            '设备详情链接'
          ]
          // 对应table数据的列字段名
          const filterVal = ['gardenName', 'name', 'deviceNo', 'param1', 'param2', 'param3', 'count', 'unit', 'url']
          excelDownload(tHeader, filterVal, this.tableData, this.$i18n.t('lang.lab_equipmentManagement'))
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      // 所属小区下拉列表获取
      getGardenId() {
        let loading = this.$loading()
        this.$get(`/gardens`).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.types = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 设备管理列表
      getTablelist() {
        let loading = this.$loading()
        if (this.gardenId != 0) {
          this.gardenIdId = this.gardenId
        }
        this.$get(
          `/device/?keyword=${this.macKeyword}&deviceTypesOf=${this.deviceTypesOf}&gardenId=${this.gardenIdId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
        ).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
              for (let i = 0; i < this.tableData.length; i++) {
                this.tableData[i].gardenName = this.tableData[i].garden.name
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getTablelist()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getTablelist()
      },
      edit(id) {
        window.localStorage.setItem('deviceManagementForm', '')
        this.$router.push({
          name: 'addDeviceManagement',
          query: {
            id: id
          }
        })
      },
      add() {
        window.localStorage.setItem('deviceManagementForm', '')
        this.$router.push({
          name: 'addDeviceManagement'
        })
      },
      commit() {
        this.pageNo = 1
        this.getTablelist()
      },
      deletetable(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          ).then(() => {
            // 添加del的url
            this.$delete(`/device/` + id).then(res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              })
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      }
    }
  }
</script>

<style lang="scss">
  .el-tooltip__popper.is-light {
    max-width: 300px;
  }

  .deviceManagementList .upload-demo {
    display: inline;
    padding-left: 20px;
  }
</style>